module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-300.cfcd7ba0.woff2";